module.exports = __webpack_public_path__ + "static/media/ic_warning.37626f7e.png";